var _path, _path2, _line, _line2, _line3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSubtitlesCharged = function SvgSubtitlesCharged(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 27.5 27.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,27.2a2.47,2.47,0,0,1-1.9-2.55q0-10.84,0-21.69A2.23,2.23,0,0,1,7.26.73,3.37,3.37,0,0,1,8.63.44c3.47,0,7,0,10.42,0A2.37,2.37,0,0,1,21.66,2.7c-.06,7.39,0,14.78,0,22.16,0,1.3-.42,1.85-1.8,2.34Zm-.55-22V22.46H20.4V5.17Zm6.53,18.35a1.37,1.37,0,0,0-1.43,1.27,1.41,1.41,0,0,0,1.46,1.26,1.37,1.37,0,0,0,1.45-1.31A1.34,1.34,0,0,0,13.82,23.52ZM13.9,2.71h0c-.38,0-.76,0-1.14,0-.12,0-.24.13-.36.2.12.09.24.25.36.25.73,0,1.47,0,2.21,0,.1,0,.21-.14.32-.22-.11-.08-.21-.22-.32-.23C14.61,2.69,14.25,2.71,13.9,2.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.59,10.05V8.51h0v-.4a1.21,1.21,0,0,0-.21-.68A.88.88,0,0,0,16.62,7h-1V6.44a.69.69,0,0,0-.72-.72c-.76,0-1.52,0-2.29,0a.64.64,0,0,0-.68.66,4.34,4.34,0,0,0,0,.51c0,.1,0,.13-.13.13-.31,0-.62,0-.93,0a.78.78,0,0,0-.58.23,1.16,1.16,0,0,0-.36.9v.35h0V20.44h0v.35a1.33,1.33,0,0,0,0,.28,1,1,0,0,0,1,.83h5.66a.85.85,0,0,0,.74-.39,1.14,1.14,0,0,0,.23-.71V19.67h0v-.6h0v-.13h0V16.72h0v-.6h0V13.81h0v-.6h0V10.66h0v-.61Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.49,
    y1: 9.16,
    x2: 19.2,
    y2: 9.07
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.39,
    y1: 12.47,
    x2: 19.1,
    y2: 12.38
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.29,
    y1: 15.83,
    x2: 18,
    y2: 15.74
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubtitlesCharged, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subtitles_charged.cd4b224b.svg";
export { ForwardRef as ReactComponent };